// removed by extract-text-webpack-plugin
module.exports = {"qualifications":"specialist-profile-header_qualifications--3zxXr5KM","specialty":"specialist-profile-header_specialty--2E_zC-tP","specialty-icon":"specialist-profile-header_specialty-icon--3HhhkDW0","specialtyIcon":"specialist-profile-header_specialty-icon--3HhhkDW0","actions":"specialist-profile-header_actions--1IiLdHu6","solid":"specialist-profile-header_solid--3eu89EtB"};


//////////////////
// WEBPACK FOOTER
// ./components/profile-header/src/styles/specialist-profile-header.scss
// module id = 1071
// module chunks = 0